import { mapActions, mapState, mapGetters } from 'vuex'
import { KEY_CODE_MAP, FOCUSABLE_ELEMENT_SELECTORS } from '@utils/keyboard-helpers'

export default {
  name: 'sidebar-links',
  data: () => ({
    toggleNav: null,
    sideBarNavigation: null,
    linksWrapper: null,
    lastHeaderItem: null,
    headerMain: null,
    bottomWrapper: null,
    body: null,
    sidebarFocusableElements: [],
    headerFocusableElements: [],
    bottomFocusableElements: []
  }),
  computed: {
    ...mapState('global', ['sidebarOpened', 'isSitecore', 'isXPE']),
    ...mapGetters('global', ['isRtl']),
    ...mapGetters('responsive', ['currentBreakpoint']),
    sidebarFirstFocusableEl() {
      return this.sidebarFocusableElements && this.sidebarFocusableElements[0]
    },
    sidebarLastFocusableEl() {
      return this.sidebarFocusableElements && this.sidebarFocusableElements[this.sidebarFocusableElements.length - 1]
    },
    headerFirstFocusableEl() {
      return this.headerFocusableElements && this.headerFocusableElements[0]
    },
    headerLastFocusableEl() {
      return this.headerFocusableElements && this.headerFocusableElements[this.headerFocusableElements.length - 1]
    },
    bottomFirstFocusableEl() {
      return this.bottomFocusableElements && this.bottomFocusableElements[0]
    },
    bottomLastFocusableEl() {
      return this.bottomFocusableElements && this.bottomFocusableElements[this.bottomFocusableElements.length - 1]
    },
    mobileLayout() {
      return this.currentBreakpoint === 'xs' || this.currentBreakpoint === 'sm' || this.currentBreakpoint === 'md'
    },
    scope() {
      return {
        openSubMenu: this.openSubMenu,
        openLevel3SubMenu: this.openLevel3SubMenu,
        slideSubMenu: this.slideSubMenu,
        restorePrimaryMobileMenu: this.restorePrimaryMobileMenu,
        openShowAllDestinations: this.openShowAllDestinations
      }
    }
  },
  watch: {
    sidebarOpened(val) {
      if (this.isXPE) return
      this.onSidebarToggle(val)
      if (val === false) {
        this.resetMenus()
        this.restorePrimaryMobileMenu()
      }
    },
    currentBreakpoint() {
      this.redefineLinksWrapper()
    }
  },
  mounted() {
    if (this.isSitecore) {
      this.$el.closest('.sidebar-navigation').classList.add('is-sitecore')
    }
    this.sideBarNavigation = document.querySelector('#sidebar-main-navigation')
    this.headerMain = document.querySelector('.header-main')
    this.toggleNav = document.querySelector('#toggle-nav')
    this.bottomWrapper = document.querySelector('.bottom-wrapper')
    this.body = document.querySelector('body')
    if (this.mobileLayout) {
      this.linksWrapper = document.querySelector('#sidebar-main-navigation .links-list.mobile')
    } else {
      this.linksWrapper = document.querySelector('#sidebar-main-navigation .desktop-wrapper')
    }
    this.getFocusableElements(this.linksWrapper, this.sidebarFocusableElements)
    this.getFocusableElements(this.headerMain, this.headerFocusableElements)
    this.getFocusableElements(this.bottomWrapper, this.bottomFocusableElements)
  },
  methods: {
    ...mapActions('global', ['toggleSidebar']),
    slideSubMenu (ev) {
      const primaryList = ev.target.closest('ul')
      const secondaryListId = ev.target.closest('li').getAttribute('aria-controls')
      const secondaryList = document.getElementById(secondaryListId)
      primaryList.classList.add('hidden')
      setTimeout(() => {
        primaryList.style.display = 'none'
        secondaryList.style.display = 'block'
      }, 50)
      setTimeout(() => {
        secondaryList.classList.add('visible')
        secondaryList.scrollIntoView()
      }, 75)
      setTimeout(() => {
        this.linksWrapper.removeEventListener('keydown', this.linksListWatcher)
        this.linksWrapper = document.querySelector('#sidebar-main-navigation .secondary-list.mobile.visible')
        this.getFocusableElements(this.linksWrapper, this.sidebarFocusableElements)
      }, 100);
      setTimeout(() => {
        this.linksWrapper.addEventListener('keydown', this.linksListWatcher)
      }, 125);
    },
    restorePrimaryMobileMenu () {
      const primaryList = document.querySelector('.links-list.mobile')
      const activeSecondaryList = document.querySelector('.secondary-list.mobile.visible')
      if (!activeSecondaryList) return
      activeSecondaryList.classList.remove('visible')
      setTimeout(() => {
        activeSecondaryList.style.display = 'none'
        this.resetOpenLevel3SubMenu()
        primaryList.style.display = 'block'
      }, 50)
      setTimeout(() => {
        primaryList.classList.remove('hidden')
      }, 75)
      setTimeout(() => {
        this.linksWrapper.removeEventListener('keydown', this.linksListWatcher)
        this.linksWrapper = document.querySelector('#sidebar-main-navigation .links-list.mobile')
        this.getFocusableElements(this.linksWrapper, this.sidebarFocusableElements)
      }, 100);
      setTimeout(() => {
        this.linksWrapper.addEventListener('keydown', this.linksListWatcher)
      }, 125);
    },
    openSubMenu (ev) {
      const itemText = ev.target
      if (itemText.classList.contains('expanded')) return
      if (itemText.classList.contains('has-secondary-list')) {
        this.resetMenus()
      }

      itemText.classList.add('expanded')
      itemText.setAttribute('aria-expanded', 'true')
      const curentSecList = itemText.querySelector('.secondary-list')
      const currentlinksList = itemText.closest('.links-list.desktop').querySelectorAll(':scope > li')
      curentSecList.style.display = 'flex'
      setTimeout(() => {
        curentSecList.style.opacity = 1
        if (this.isRtl) {
          curentSecList.style.right = '285px'
        } else {
          curentSecList.style.left = '285px'
        }
      }, 100)
       currentlinksList.forEach(item => {
        if(!item.classList.contains('expanded') && !this.mobileLayout) {
          item.classList.add('in-active')
        }

      })
    },
    openLevel3SubMenu (ev) {
      const itemText = ev.target
      if (!itemText.classList.contains('expanded')) {
        this.resetOpenLevel3SubMenu()
        itemText.classList.add('expanded')
        itemText.setAttribute('aria-expanded', 'true')
        const curentSecList = itemText.parentNode.querySelector('.secondary-list-subitems')
        curentSecList.classList.add('show')
      } else {
        this.resetOpenLevel3SubMenu()
        itemText.classList.remove('expanded')
        itemText.setAttribute('aria-expanded', 'false')
        const curentSecList = itemText.parentNode.querySelector('.secondary-list-subitems')
        curentSecList.classList.remove('show')
      }
    },
    resetOpenLevel3SubMenu () {
      const mobileLevel3Container = this.$el.querySelector('.secondary-list.mobile')
      const mobileLevel3Buttons = mobileLevel3Container.querySelectorAll('.secondary-list-subitem-group-label')
      const mobileLevel3List = mobileLevel3Container.querySelectorAll('.secondary-list-subitems')
      mobileLevel3Buttons.forEach(item => {
        item.classList.remove('expanded')
        item.setAttribute('aria-expanded', 'false')
      })
      mobileLevel3List.forEach(item => {
        item.classList.remove('show')
      })
    },
    openShowAllDestinations () {
      const showAllDestinationsButtons = this.$el.querySelectorAll('.showall-destinations-target')
      showAllDestinationsButtons.forEach(item => {
        if (!this.mobileLayout) {
          this.$el.parentNode.querySelector('.showall-destinations-target').click()
          this.$el.querySelector('.showall-destinations-target').focus()
        }
      })
    },
    resetMenus () {
      const desktopMenu = this.$el.querySelector('.links-list.desktop')
      const desktopItems = desktopMenu.querySelectorAll('li.has-secondary-list')
      const desktopMenuL1Links = desktopMenu.querySelectorAll(':scope > li')
      desktopItems.forEach(item => {
        item.classList.remove('expanded')
        item.setAttribute('aria-expanded', 'false')
      })
      const subMenus = desktopMenu.querySelectorAll('.secondary-list')
      subMenus.forEach(subMenu => {
        subMenu.style.display = 'none'
        subMenu.style.opacity = 0
        if (this.isRtl) {
          subMenu.style.right = '146px'
        } else {
          subMenu.style.left = '146px'
        }
      });
      desktopMenuL1Links.forEach(item => {
        item.classList.remove('in-active')
      })
    },
    redefineLinksWrapper () {
      this.linksWrapper.removeEventListener('keydown', this.linksListWatcher)
      if (this.mobileLayout) {
        const mobilePrimaryList = document.querySelector('#sidebar-main-navigation .links-list.mobile')
        const mobileSecondaryList = document.querySelector('#sidebar-main-navigation .secondary-list.mobile.visible')
        if (!mobilePrimaryList.classList.contains('hidden')) {
          this.linksWrapper = mobilePrimaryList
        } else {
          this.linksWrapper = mobileSecondaryList
        }
        this.getFocusableElements(this.linksWrapper, this.sidebarFocusableElements)
      } else {
        this.linksWrapper = document.querySelector('#sidebar-main-navigation .desktop-wrapper')
        this.getFocusableElements(this.linksWrapper, this.sidebarFocusableElements)
      }
      setTimeout(() => {
        this.linksWrapper.addEventListener('keydown', this.linksListWatcher)
      }, 100);
    },
    getFocusableElements(element, array) {
      array.splice(0)
      element.querySelectorAll(FOCUSABLE_ELEMENT_SELECTORS).forEach(el => array.push(el))
    },
    onSidebarToggle(open) {
      if (open) {
        this.sideBarNavigation.classList.add('opened', 'to-front')
        this.toggleNav.classList.add('opened')
        this.body.style.overflowY = 'hidden'
        this.openShowAllDestinations()
        this.bindListeners()
      } else {
        this.sideBarNavigation.classList.remove('opened')
        setTimeout(() => this.sideBarNavigation.classList.remove('to-front'), 200)
        this.toggleNav.classList.remove('opened')
        this.toggleNav.focus()
        this.body.style.overflowY = 'auto'
        this.unbindListeners()
      }
    },
    bindListeners () {
      this.linksWrapper.addEventListener('keydown', this.linksListWatcher)
      this.headerMain.addEventListener('keydown', this.headerWatcher)
      this.bottomWrapper.addEventListener('keydown', this.bottomElementsWatcher)
    },
    unbindListeners () {
      this.headerMain.removeEventListener('keydown', this.headerWatcher)
      this.linksWrapper.removeEventListener('keydown', this.linksListWatcher)
      this.bottomWrapper.removeEventListener('keydown', this.bottomElementsWatcher)
    },
    linksListWatcher(e) {
      if (e.keyCode === KEY_CODE_MAP.TAB) {
        if (e.shiftKey && document.activeElement.outerHTML === this.sidebarFirstFocusableEl.outerHTML) {
          e.preventDefault();
          e.stopPropagation();
          this.headerLastFocusableEl.focus();
        }
      } else if (e.keyCode === KEY_CODE_MAP.ESCAPE) {
        this.toggleSidebar(false)
      }
    },
    headerWatcher(e) {
      if (e.keyCode === KEY_CODE_MAP.TAB) {
        if (e.shiftKey && document.activeElement.outerHTML === this.headerFirstFocusableEl.outerHTML) {
          e.preventDefault();
          e.stopPropagation();
          this.bottomLastFocusableEl.focus();
        }
      } else if (e.keyCode === KEY_CODE_MAP.ESCAPE) {
        this.toggleSidebar(false)
      }
    },
    bottomElementsWatcher(e) {
      if (e.keyCode === KEY_CODE_MAP.TAB) {
        if (e.shiftKey && document.activeElement.outerHTML === this.bottomFirstFocusableEl.outerHTML) {
          e.preventDefault();
          e.stopPropagation();
          this.sidebarLastFocusableEl.focus();
        } else if (!e.shiftKey && document.activeElement.outerHTML === this.bottomLastFocusableEl.outerHTML) {
          e.preventDefault();
          e.stopPropagation();
          this.headerFirstFocusableEl.focus();
        }
      } else if (e.keyCode === KEY_CODE_MAP.ESCAPE) {
        this.toggleSidebar(false)
      }
    },
  },
  render() {
    return this.$scopedSlots.default(this.scope)
  }
}
